module.exports = __webpack_public_path__ + "img/signal-start.2eb93c18.svg";